//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('SearchFilterCachingService', [
    '$log',
    'SearchFilterService',
    function(
            $log,
            SearchFilterService,
        ) {
      const cachedFilterSets = new Map();

      this.getCachedFilterSet = (cacheId) => {
        return angular.copy(cachedFilterSets.get(cacheId));
      };

      this.cacheFilterSet = (cacheId, filterSetName) => {
        const filterSet = angular.copy(SearchFilterService.getRegisteredSet(filterSetName));
        cachedFilterSets.set(cacheId, filterSet.params);
      };

      this.clearAllCachedFilterSets = () => {
        cachedFilterSets.clear();
      };
    },
  ]);
})();
